module.exports = __webpack_public_path__ + "img/FP-LOGO.984e124a.svg";